import axiosInstance from "../lib/axios";

export const getProducts = async (
  categoryId: number,
  subCategoryId?: number,
  page?: number,
  limit?: number
) => {
  const params: any = {
    categoryId,
    subCategoryId,
    page: page ?? 1,
    limit: limit ?? 50,
  };

  if (subCategoryId) {
    params.subCategoryId = subCategoryId;
  }

  const { data } = await axiosInstance.post("/Product/List",  params );

  return data;
};

export interface SearchProductParams {
  q?: string;
  page?: number;
  limit?: number;
  category_id?: number;
  subcategory_id?: number;
}

export const searchProduct = async (params: SearchProductParams) => {
  const { data } = await axiosInstance.get("/Product/Search", { params });
  return data;
};

export const getProductById = (id: number) => {
  return axiosInstance.get(`/Product/${id}`);
};